import * as firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/storage';

declare const REACT_APP_API_KEY: string;
declare const REACT_APP_AUTH_DOMAIN: string;
declare const REACT_APP_DATABASE_URL: string;
declare const REACT_APP_PROJECT_ID: string;
declare const REACT_APP_STORAGE_BUCKET: string;
declare const REACT_APP_MESSAGING_SENDER_ID: string;
declare const REACT_APP_APP_ID: string;

const config = {
  apiKey: REACT_APP_API_KEY,
  authDomain: REACT_APP_AUTH_DOMAIN,
  databaseURL: REACT_APP_DATABASE_URL,
  projectId: REACT_APP_PROJECT_ID,
  storageBucket: REACT_APP_STORAGE_BUCKET,
  messagingSenderId: REACT_APP_MESSAGING_SENDER_ID,
  appId: REACT_APP_APP_ID,
};

firebase.initializeApp(config);
firebase.auth().useDeviceLanguage();

export default firebase;
